import IncidentsManage from './IncidentsManage.container';
export default IncidentsManage;
